var _rect, _g, _rect2, _g2, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreThubnailSlides(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 65,
    viewBox: "0 0 116 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1586_107284",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 116,
    height: 65
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 65,
    rx: 14,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1586_107284)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 65,
    fill: "#F8F8F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1586_107284",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 1,
    width: 64,
    height: 64
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 1,
    width: 64,
    height: 64,
    rx: 14,
    fill: "#F8F8F8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1586_107284)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 1,
    width: 64,
    height: 64,
    fill: "url(#pattern0)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 115,
    height: 64,
    rx: 13.5,
    stroke: "#E8E9EB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1586_107284",
    transform: "scale(0.0135135)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1586_107284",
    width: 74,
    height: 74,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABKCAYAAAAc0MJxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJ7SURBVHgB7dpBSyMxGMbx16WHCl3oQhdccMG9uaCgon7/s4p6V1CwYMGCPRQcsKB5hr6iZayPdZKM+vxBpB6q/TVJkxmXiqJ4MPVmP0xRCYpMUGSCIhMUmaDIBEUmKDJBkQmKTFBkgiITFJmgyARFJigyQZEJikxQZIIiExSZoMgERdayBN1PJtbv9200Glmd9Xo9+7OyYq1W/JexFPsGKJAOj44s/B6LUbvdtv3d3ehY0d+KwWDwhPSr2y1fWB1NwhtwMxyWz30VRuu/tTWLWXSoYXgx6HeYJpsbG1ZnJ6endhumc91Tuqpki3mMqVHX6GRKsphX5Qs8pk43TEmMuBSL8qJl+cvuAg6mja9d12Edu0i0KC9aln0U1hRH+tnplN/xGGBNLRsU6gSkvTCKOlOs8XhsTS0LlC/CgDkIeywHwlpVFT7+MVXvIu3FmLJA/V1dfYGF8BgL+mwXl5d2dn5ebgNyYmVZObFgY+HGhhHTEFOv6igCJHx5xfRDYHtry5YTbg1QtkMxUIDzf329HGHzkADpO2/HSj2yGvlZPIu0E0aQQ+LnjrX8HTacrzUPyUeVYxUJR1WjrkfNQ/KAFfsAXFVjoBgkLwdWI6Deg+QBqmo7EavsUIsgeSnPhVmhPoKUumxQnwkJZYH6bEgoGZTveepEwnXzVEV/G3FFAAdafB2H3fTz69s4COPAu0g4wvhz9RJ8+kWHwjnuenonZvYmgN94+EjAxpkxdtHv6yFMEWDVAfM8jNaqA3WMkkB9hfS/B2SCIhMUmaDIBEUmKDJBkQmKTFBkgiITFJmgyARFJigyQZEJikxQZIIiExSZoMgERSYoMkGRPQJgmycwx2zphAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreThubnailSlides);
export default __webpack_public_path__ + "static/media/moreThubnailSlides.18acdaea4390c53d25c00ac05d6a7ef6.svg";
export { ForwardRef as ReactComponent };